import VueRouter from 'vue-router';
import store from './store';
//页面组件
import home from './views/home.vue';
import rule from './views/rule.vue';
const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/rule',
    name: 'rule',
    component: rule,
    meta: {
      title: '活动规则'
    }
  },
  {
    path: '/my_awards',
    name: 'myAwards',
    component: () => import('./views/myAwards'),
    meta: {
      title: '我的奖励'
    }
  },
  {
    path: '/my_center',
    name: 'myCenter',
    component: () => import('./components/MyCenter'),
    meta: {
      title: '我的中心'
    }
  },
  {
    path: '/invited_award',
    name: 'invitedAward',
    component: () => import('./components/InvitedAward.vue'),
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/account_error',
    name: 'account_error',
    component: () => import('./views/AccountError'),
    meta: {
      title: '账号异常'
    }
  },
  {
    path: '/testShare',
    name: 'testShare',
    component: () => import('./views/testShare.vue'),
    meta: {
      title: '测试分享'
    }
  }
];
const router = new VueRouter({
  routes
});

//全局路由器钩子，跳转之前
router.beforeEach((to, from, next) => {
  console.log(store.state, 'store.state');
  if (to.query && to.query.doc_title) {
    // 修改页面标题
    document.title = to.query.doc_title;
  } else if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
